/* VB · pie: al entrar en pantalla, marca, columnas y bloque lateral aparecen escalonados (subida corta + fundido, CSS).
   Solo arma la animación si hay IntersectionObserver y sin reduced-motion; con la pestaña oculta se muestra ya. */
(() => {
  const init = (root) => {
    if (!root || root.__vbFooter) return;
    root.__vbFooter = true;
    if (matchMedia('(prefers-reduced-motion: reduce)').matches || !('IntersectionObserver' in window)) return;
    const r = root.getBoundingClientRect();
    if (r.top < innerHeight * 0.9 && r.bottom > 0) return; // ya visible al cargar (páginas cortas): sin parpadeo
    root.classList.add('is-armed');
    const show = () => { root.classList.add('is-in'); io.disconnect(); };
    const io = new IntersectionObserver((es) => { if (es.some((e) => e.isIntersecting)) show(); }, { threshold: 0.12, rootMargin: '0px 0px -8% 0px' });
    io.observe(root);
    document.addEventListener('visibilitychange', () => { if (document.hidden) show(); });
  };
  /* Logo del pie (Nicolas 28-oct: «animación creativa siguiendo la identidad»): «Vera» y «Belleza» se parten en letras.
     Al entrar en pantalla las letras emergen una a una (suben desde abajo, desenfocadas y giradas, y se asientan); al
     terminar, una onda de luz recorre «Belleza» (cada letra se aclara y vuelve al burdeos). Con ratón: las letras hacen
     una ola al pasar por encima. Solo transform/opacity/filter/color; «reducir movimiento» = logo quieto. */
  const logo = (root) => {
    const a = root.querySelector('.vb-footer__logo');
    if (!a || a.__vbLogo || !a.querySelector('.vb-footer__logo-light, .vb-footer__logo-bold')) return;
    a.__vbLogo = true;
    let i = 0;
    a.querySelectorAll('.vb-footer__logo-light, .vb-footer__logo-bold').forEach((part) => {
      const txt = part.textContent;
      part.textContent = '';
      [...txt].forEach((ch) => {
        const s = document.createElement('span');
        s.className = 'vb-lt';
        s.setAttribute('aria-hidden', 'true');
        s.style.setProperty('--i', i++);
        s.textContent = ch === ' ' ? '\u00a0' : ch;
        part.appendChild(s);
      });
    });
    if (matchMedia('(prefers-reduced-motion: reduce)').matches || !('IntersectionObserver' in window)) return;
    a.classList.add('is-armed');
    const go = () => { a.classList.add('is-in'); io.disconnect(); setTimeout(() => a.classList.add('is-shine'), 1500); };
    const io = new IntersectionObserver((es) => { if (es.some((e) => e.isIntersecting)) go(); }, { threshold: 0.6 });
    io.observe(a);
    document.addEventListener('visibilitychange', () => { if (document.hidden) go(); });
  };
  const run = (scope = document) => scope.querySelectorAll('[data-vb-footer]').forEach((r) => { init(r); logo(r); });
  run();
  document.addEventListener('shopify:section:load', (e) => run(e.target));
})();
